import React, { createContext, useState, useEffect, useContext } from 'react';
import axios from 'axios';

export const SettingsContext = createContext();

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({
    siteName: 'Centre Techniques Pianos',
    siteDescription: 'Premium musical instruments and professional audio equipment',
    contactEmail: '',
    contactPhone: '',
    socialMedia: {},
    currency: 'NGN',
    taxRate: 7.5,
    shippingFee: 5000,
    freeShippingThreshold: 250000,
    heroEyebrow: '',
    heroTitle: '',
    heroSubtitle: '',
    heroImage: '',
  });
  const [loading, setLoading] = useState(true);

  const loadSettings = async () => {
    try {
      const res = await axios.get('/api/settings');
      setSettings((prev) => ({ ...prev, ...res.data }));
    } catch (error) {
      console.error('Error loading settings:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadSettings();
  }, []);

  return (
    <SettingsContext.Provider value={{ settings, loading, refreshSettings: loadSettings }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => {
  const ctx = useContext(SettingsContext);
  if (!ctx) throw new Error('useSettings must be used inside SettingsProvider');
  return ctx;
};
